export const symbols = [
  {
    "symbol": "AUDCAD.pro",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "CAD",
    "description": "Australian Dollar vs Canadian Dollar"
  },
  {
    "symbol": "AUDCHF.pro",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "CHF",
    "description": "Australian Dollar vs Swiss Franc"
  },
  {
    "symbol": "AUDJPY.pro",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "JPY",
    "description": "Australian Dollar vs Japanese Yen"
  },
  {
    "symbol": "AUDNZD.pro",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "NZD",
    "description": "Australian Dollar vs New Zealand Dollar"
  },
  {
    "symbol": "AUDUSD.pro",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "USD",
    "description": "Australian Dollar vs US Dollar"
  },
  {
    "symbol": "CADCHF.pro",
    "symbolType": "Forex",
    "currencyBase": "CAD",
    "currencyQuote": "CHF",
    "description": "Canadian Dollar vs Swiss Franc"
  },
  {
    "symbol": "CADJPY.pro",
    "symbolType": "Forex",
    "currencyBase": "CAD",
    "currencyQuote": "JPY",
    "description": "Canadian Dollar vs Japanese Yen"
  },
  {
    "symbol": "CHFJPY.pro",
    "symbolType": "Forex",
    "currencyBase": "CHF",
    "currencyQuote": "JPY",
    "description": "Swiss Franc vs Japanese Yen"
  },
  {
    "symbol": "EURAUD.pro",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "AUD",
    "description": "Euro vs Australian Dollar"
  },
  {
    "symbol": "EURCAD.pro",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "CAD",
    "description": "Euro vs Canadian Dollar"
  },
  {
    "symbol": "EURCHF.pro",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "CHF",
    "description": "Euro vs Swiss Franc"
  },
  {
    "symbol": "EURGBP.pro",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "GBP",
    "description": "Euro vs Great Britain Pound"
  },
  {
    "symbol": "EURJPY.pro",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "JPY",
    "description": "Euro vs Japanese Yen"
  },
  {
    "symbol": "EURNZD.pro",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "NZD",
    "description": "Euro vs New Zealand Dollar"
  },
  {
    "symbol": "EURUSD.pro",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "USD",
    "description": "Euro vs US Dollar"
  },
  {
    "symbol": "GBPAUD.pro",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "AUD",
    "description": "Great Britain Pound vs Australian Dollar"
  },
  {
    "symbol": "GBPCAD.pro",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "CAD",
    "description": "Great Britain Pound vs Canadian Dollar"
  },
  {
    "symbol": "GBPCHF.pro",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "CHF",
    "description": "Great Britain Pound vs Swiss Franc"
  },
  {
    "symbol": "GBPJPY.pro",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "JPY",
    "description": "Great Britain Pound vs Japanese Yen"
  },
  {
    "symbol": "GBPNZD.pro",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "NZD",
    "description": "Great Britan Pound vs New Zealand Dollar"
  },
  {
    "symbol": "GBPSGD.pro",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "SGD",
    "description": "Great Britain Pound vs Singapore Dollar"
  },
  {
    "symbol": "GBPUSD.pro",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "USD",
    "description": "Great Britain Pound vs US Dollar"
  },
  {
    "symbol": "NZDCAD.pro",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "CAD",
    "description": "New Zealand Dollar vs Canadian Dollar"
  },
  {
    "symbol": "NZDCHF.pro",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "CHF",
    "description": "New Zealand Dollar vs Swiss Franc"
  },
  {
    "symbol": "NZDJPY.pro",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "JPY",
    "description": "New Zealand Dollar vs Japanise Yen"
  },
  {
    "symbol": "NZDUSD.pro",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "USD",
    "description": "New Zealand Dollar vs US Dollar"
  },
  {
    "symbol": "USDCAD.pro",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "CAD",
    "description": "US Dollar vs Canadian Dollar"
  },
  {
    "symbol": "USDCHF.pro",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "CHF",
    "description": "US Dollar vs Swiss Franc"
  },
  {
    "symbol": "USDHKD.pro",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "HKD",
    "description": "US Dollar vs Hong Kong Dollar"
  },
  {
    "symbol": "USDJPY.pro",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "JPY",
    "description": "US Dollar vs Japanese Yen"
  },
  {
    "symbol": "USDSGD.pro",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "SGD",
    "description": "US Dollar vs Singapour Dollar"
  },
  {
    "symbol": "XAGUSD.pro",
    "symbolType": "Forex",
    "currencyBase": "XAG",
    "currencyQuote": "USD",
    "description": "Silver vs US Dollar"
  },
  {
    "symbol": "XAUUSD.pro",
    "symbolType": "Forex",
    "currencyBase": "XAU",
    "currencyQuote": "USD",
    "description": "Gold vs US Dollar"
  },
  {
    "symbol": "EUSTX50.pro",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "EUR",
    "description": "EU Stocks 50 Cach - EUR"
  },
  {
    "symbol": "GER30.pro",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "EUR",
    "description": "Germany 30 (DAX) Cash - EUR"
  },
  {
    "symbol": "UK100.pro",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "GBP",
    "description": "UK 100 Cash - GBP"
  },
  {
    "symbol": "HK50.pro",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "HKD",
    "description": "Hong Kong 50 cash, Hong Kong Dollar"
  },
  {
    "symbol": "JPN225.pro",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "JPY",
    "description": "Japan 225 Cash - JPY"
  },
  {
    "symbol": "NAS100.pro",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",
    "contractSize": 1,
    "description": "US Tech 100 Cash - USD"
  },
  {
    "symbol": "UKOIL.pro",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",
    "description": "Brent Crude vs US Dollar"
  },
  {
    "symbol": "US30.pro",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",    
    "description": "US Wall Street 30 Cash - USD"
  },
  {
    "symbol": "US500.pro",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",    
    "description": "US SPX 500 Cash - USD"
  },
  {
    "symbol": "USOIL.pro",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",
    "description": "West Texas Intermediate vs US Dollar"
  },
  {
    "symbol": "AUDCAD.am",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "CAD",
    "description": "Australian Dollar vs Canadian Dollar"
  },
  {
    "symbol": "AUDCHF.am",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "CHF",
    "description": "Australian Dollar vs Swiss Franc"
  },
  {
    "symbol": "AUDJPY.am",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "JPY",
    "description": "Australian Dollar vs Japanise Yen"
  },
  {
    "symbol": "AUDNZD.am",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "NZD",
    "description": "Australian Dollar vs New Zealand Dollar"
  },
  {
    "symbol": "AUDUSD.am",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "USD",
    "description": "Australian Dollar vs US Dollar"
  },
  {
    "symbol": "CADCHF.am",
    "symbolType": "Forex",
    "currencyBase": "CAD",
    "currencyQuote": "CHF",
    "description": "Canadian Dollar vs Swiss Franc"
  },
  {
    "symbol": "CADJPY.am",
    "symbolType": "Forex",
    "currencyBase": "CAD",
    "currencyQuote": "JPY",
    "description": "Canadian Dollar vs Japanise Yen"
  },
  {
    "symbol": "CHFJPY.am",
    "symbolType": "Forex",
    "currencyBase": "CHF",
    "currencyQuote": "JPY",
    "description": "Swiss Franc vs Japanise Yen"
  },
  {
    "symbol": "EURAUD.am",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "AUD",
    "description": "Euro vs Australian Dollar"
  },
  {
    "symbol": "EURCAD.am",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "CAD",
    "description": "Euro vs Canadian Dollar"
  },
  {
    "symbol": "EURCHF.am",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "CHF",
    "description": "Euro vs Swiss Franc"
  },
  {
    "symbol": "EURGBP.am",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "GBP",
    "description": "Euro vs Great Britain Pound "
  },
  {
    "symbol": "EURJPY.am",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "JPY",
    "description": "Euro vs Japanese Yen"
  },
  {
    "symbol": "EURNZD.am",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "NZD",
    "description": "Euro vs New Zealand Dollar"
  },
  {
    "symbol": "EURUSD.am",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "USD",
    "description": "Euro vs US Dollar"
  },
  {
    "symbol": "GBPAUD.am",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "AUD",
    "description": "Great Britan Pound vs Australian Dollar"
  },
  {
    "symbol": "GBPCAD.am",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "CAD",
    "description": "Great Britan Pound vs Canadian Dollar"
  }, 
  {
    "symbol": "GBPCHF.am",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "CHF",
    "description": "Great Britain Pound vs Swiss Franc"
  }, 
  {
    "symbol": "GBPJPY.am",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "JPY",
    "description": "Great Britain Pound vs Japanese Yen"
  }, 
  {
    "symbol": "GBPNZD.am",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "NZD",
    "description": "Great Britan Pound vs New Zealand Dollar"
  }, 
  {
    "symbol": "GBPSGD.am",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "SGD",
    "description": "Great Britain Pound vs Singapore Dollar"
  }, 
  {
    "symbol": "GBPUSD.am",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "USD",
    "description": "Great Britain Pound vs US Dollar"
  }, 
  {
    "symbol": "NZDCAD.am",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "CAD",
    "description": "New Zealand Dollar vs Canadian Dollar"
  },
  {
    "symbol": "NZDCHF.am",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "CHF",
    "description": "New Zealand Dollar vs Swiss Franc"
  },
  {
    "symbol": "NZDJPY.am",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "JPY",
    "description": "New Zealand Dollar vs Japanise Yen"
  },
  {
    "symbol": "NZDUSD.am",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "USD",
    "description": "New Zealand Dollar vs US Dollar"
  },
  {
    "symbol": "USDCAD.am",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "CAD",
    "description": "US Dollar vs Canadian Dollar"
  },
  {
    "symbol": "USDCHF.am",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "CHF",
    "description": "US Dollar vs Swiss Franc"
  },
  {
    "symbol": "USDHKD.am",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "HKD",
    "description": "US Dollar vs Hong Kong Dollar"
  },
  {
    "symbol": "USDJPY.am",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "JPY",
    "description": "US Dollar vs Japanese Yen"
  },
  {
    "symbol": "USDSGD.am",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "SGD",
    "description": "US Dollar vs Singapour Dollar"
  },
  {
    "symbol": "XAGUSD.am",
    "symbolType": "Forex",
    "currencyBase": "XAG",
    "currencyQuote": "USD",
    "description": "Silver vs US Dollar"
  },
  {
    "symbol": "XAUUSD.am",
    "symbolType": "Forex",
    "currencyBase": "XAU",
    "currencyQuote": "USD",
    "description": "Gold vs US Dollar"
  },
  {
    "symbol": "EUSTX50.am",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "EUR",    
    "description": "EU Stocks 50 Cach - EUR"
  },
  {
    "symbol": "GER30.am",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "EUR",    
    "description": "Germany 30 (DAX) Cash - EUR"
  },
  {
    "symbol": "HK50.am",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "HKD",    
    "description": "Hong Kong 50 cash, Hong Kong Dollar"
  },
  {
    "symbol": "JPN225.am",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "JPY",
    "description": "Japan 225 Cash - JPY"
  },
  {
    "symbol": "NAS100.am",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",    
    "description": "US Tech 100 Cash - USD"
  },
  {
    "symbol": "UK100.am",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "GBP",    
    "description": "UK 100 Cash - GBP"
  },
  {
    "symbol": "UKOIL.am",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",
    "description": "Brent Crude vs US Dollar"
  },
  {
    "symbol": "US30.am",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",    
    "description": "US Wall Street 30 Cash - USD"
  },
  {
    "symbol": "US500.am",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",    
    "description": "US SPX 500 Cash - USD"
  },
  {
    "symbol": "USOIL.am",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",
    "description": "West Texas Intermediate vs US Dollar"
  },
  {
    "symbol": "AUDCAD.raw",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "CAD",
    "description": "Australian Dollar vs Canadian Dollar"
  },
  {
    "symbol": "AUDCHF.raw",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "CHF",
    "description": "Australian Dollar vs Swiss Franc"
  },
  {
    "symbol": "AUDJPY.raw",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "JPY",
    "description": "Australian Dollar vs Japanise Yen"
  },
  {
    "symbol": "AUDNZD.raw",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "NZD",
    "description": "Australian Dollar vs New Zealand Dollar"
  },
  {
    "symbol": "AUDUSD.raw",
    "symbolType": "Forex",
    "currencyBase": "AUD",
    "currencyQuote": "USD",
    "description": "Australian Dollar vs US Dollar"
  },
  {
    "symbol": "CADCHF.raw",
    "symbolType": "Forex",
    "currencyBase": "CAD",
    "currencyQuote": "CHF",
    "description": "Canadian Dollar vs Swiss Franc"
  },
  {
    "symbol": "CADJPY.raw",
    "symbolType": "Forex",
    "currencyBase": "CAD",
    "currencyQuote": "JPY",
    "description": "Canadian Dollar vs Japanise Yen"
  },
  {
    "symbol": "CHFJPY.raw",
    "symbolType": "Forex",
    "currencyBase": "CHF",
    "currencyQuote": "JPY",
    "description": "Swiss Franc vs Japanise Yen"
  },
  {
    "symbol": "EURAUD.raw",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "AUD",
    "description": "Euro vs Australian Dollar"
  },
  {
    "symbol": "EURCAD.raw",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "CAD",
    "description": "Euro vs Canadian Dollar"
  },
  {
    "symbol": "EURCHF.raw",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "CHF",
    "description": "Euro vs Swiss Franc"
  },
  {
    "symbol": "EURGBP.raw",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "GBP",
    "description": "Euro vs Great Britain Pound "
  },
  {
    "symbol": "EURJPY.raw",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "JPY",
    "description": "Euro vs Japanese Yen"
  },
  {
    "symbol": "EURNZD.raw",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "NZD",
    "description": "Euro vs New Zealand Dollar"
  },
  {
    "symbol": "EURUSD.raw",
    "symbolType": "Forex",
    "currencyBase": "EUR",
    "currencyQuote": "USD",
    "description": "Euro vs US Dollar"
  },
  {
    "symbol": "GBPAUD.raw",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "AUD",
    "description": "Great Britan Pound vs Australian Dollar"
  },
  {
    "symbol": "GBPCAD.raw",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "CAD",
    "description": "Great Britan Pound vs Canadian Dollar"
  },
  {
    "symbol": "GBPCHF.raw",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "CHF",
    "description": "Great Britain Pound vs Swiss Franc"
  },
  {
    "symbol": "GBPJPY.raw",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "JPY",
    "description": "Great Britain Pound vs Japanese Yen"
  },
  {
    "symbol": "GBPNZD.raw",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "NZD",
    "description": "Great Britan Pound vs New Zealand Dollar"
  },
  {
    "symbol": "GBPSGD.raw",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "SGD",
    "description": "Great Britain Pound vs Singapore Dollar"
  },
  {
    "symbol": "GBPUSD.raw",
    "symbolType": "Forex",
    "currencyBase": "GBP",
    "currencyQuote": "USD",
    "description": "Great Britain Pound vs US Dollar"
  },
  {
    "symbol": "NZDCAD.raw",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "CAD",
    "description": "New Zealand Dollar vs Canadian Dollar"
  },
  {
    "symbol": "NZDCHF.raw",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "CHF",
    "description": "New Zealand Dollar vs Swiss Franc"
  },
  {
    "symbol": "NZDJPY.raw",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "JPY",
    "description": "New Zealand Dollar vs Japanise Yen"
  },
  {
    "symbol": "NZDUSD.raw",
    "symbolType": "Forex",
    "currencyBase": "NZD",
    "currencyQuote": "USD",
    "description": "New Zealand Dollar vs US Dollar"
  },
  {
    "symbol": "USDCAD.raw",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "CAD",
    "description": "US Dollar vs Canadian Dollar"
  },
  {
    "symbol": "USDCHF.raw",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "CHF",
    "description": "US Dollar vs Swiss Franc"
  },
  {
    "symbol": "USDHKD.raw",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "HKD",
    "description": "US Dollar vs Hong Kong Dollar"
  },
  {
    "symbol": "USDJPY.raw",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "JPY",
    "description": "US Dollar vs Japanese Yen"
  },
  {
    "symbol": "USDSGD.raw",
    "symbolType": "Forex",
    "currencyBase": "USD",
    "currencyQuote": "SGD",
    "description": "US Dollar vs Singapour Dollar"
  },
  {
    "symbol": "XAGUSD.raw",
    "symbolType": "Forex",
    "currencyBase": "XAG",
    "currencyQuote": "USD",
    "description": "Silver vs US Dollar"
  },
  {
    "symbol": "XAUUSD.raw",
    "symbolType": "Forex",
    "currencyBase": "XAU",
    "currencyQuote": "USD",
    "description": "Gold vs US Dollar"
  },
  {
    "symbol": "EUSTX50.raw",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",    
    "description": "EU Stocks 50 Cach - EUR"
  },
  {
    "symbol": "GER30.raw",
    "symbolType": "CFD_Leverage",
    "currencyBase": "EUR",
    "currencyQuote": "EUR",    
    "description": "Germany 30 (DAX) Cash - EUR"
  },
  {
    "symbol": "HK50.raw",
    "symbolType": "CFD_Leverage",
    "currencyBase": "HKD",
    "currencyQuote": "HKD",    
    "description": "Hong Kong 50 cash, Hong Kong Dollar"
  },
  {
    "symbol": "JPN225.raw",
    "symbolType": "CFD_Leverage",
    "currencyBase": "JPY",
    "currencyQuote": "JPY",
    "description": "Japan 225 Cash - JPY"
  },
  {
    "symbol": "NAS100.raw",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",    
    "description": "US Tech 100 Cash - USD"
  },
  {
    "symbol": "UK100.raw",
    "symbolType": "CFD_Leverage",
    "currencyBase": "GBP",
    "currencyQuote": "GBP",    
    "description": "UK 100 Cash - GBP"
  },
  {
    "symbol": "UKOIL.raw",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",
    "description": "Brent Crude vs US Dollar"
  },
  {
    "symbol": "US30.raw",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",    
    "description": "US Wall Street 30 Cash - USD"
  },
  {
    "symbol": "US500.raw",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",    
    "description": "US SPX 500 Cash - USD"
  },
  {
    "symbol": "USOIL.raw",
    "symbolType": "CFD_Leverage",
    "currencyBase": "USD",
    "currencyQuote": "USD",
    "description": "West Texas Intermediate vs US Dollar"
  }
  ]
